import tests from '../../helpers/tests';

const { viewerIsNotThehiveRsAdmin } = tests;

export default [
  'PageSingle',
  {
    // icon: 'tool',
    path: '/settings/magic-text',
    title: 'Magic Text',
    headerTitle: 'Magic Text',
    renderHeaderTitle: () => 'Magic Text',
    hidden: false,
    activity: 'edit',
    url: '/settings/magicText',
    redirect: [['redirect.unauthorized']],
    actions: [['ActionSave']],
    skip: [viewerIsNotThehiveRsAdmin],
    fields: [
      ['FieldTextArea', {
        name: 'defaultPrompt',
        label: null,
        placeholder: 'Prompt template for AI',
        autoSize: { minRows: 3 },
        fontFamily: 'Menlo',
        fontSize: '80%',
        disabled: [viewerIsNotThehiveRsAdmin],
      }],
    ],
  },
];
